let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("44WCz")).then(() => parcelRequire('ejM7W'));